import './FieldErrors.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';

import {
  FieldErrorsDefaultProps,
  FieldErrorsPropTypes,
} from '@/common/components/molecules/FieldErrors/FieldErrors.proptypes';

const FieldErrors = ({ className, context, errors, icon, id, name }) => {
  const conditionalProps = useMemo(
    () => ({
      ...(id ? { id } : {}),
      ...{ 'data-qa-id': context || 'errors-field' },
    }),
    [context, id],
  );

  if (!errors.filter((val) => val).length) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ul {...conditionalProps} className={cn('field-errors', className)}>
      {errors.map((error, index) => (
        <li
          className="field-errors__item"
          key={`${name}-list-error-${index}`}
          data-qa-id="error"
        >
          {icon && (
            <span className="field-errors__icon" data-qa-id="icon">
              {icon}
            </span>
          )}
          <span className="field-errors__text" data-qa-id="message">
            {error}
          </span>
        </li>
      ))}
    </ul>
  );
};

FieldErrors.defaultProps = {
  ...FieldErrorsDefaultProps,
};

FieldErrors.propTypes = {
  ...FieldErrorsPropTypes,
};

export default FieldErrors;
